import React, { useState, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import ErrorPage from '../Pages/Error/Error'
import fp from 'lodash/fp'

/**
 * @type {React.Context<{ onError: (options: { errCode: any, errMessage: any, onBack: () => void }) => void }>}
 */
const ErrorContext = React.createContext()

export const ErrorProvider = ({ children }) => {
  const history = useHistory()
  const [ state, setState ] = useState({
    isError: false,
    errCode: null,
    errMessage: null,
    onBack: null,
  })

  const onError = useCallback(({ 
    errCode, 
    errMessage,
    onBack
  }) => {
    console.log("🚨 [ErrorContext] onError 被呼叫")
    console.log({ errCode, errMessage, onBack });

  

    setState(fp.assign(fp.__, {
      isError: true,
      errCode,
      errMessage,
      onBack
    }))
  }, [])
  
  return (
    <ErrorContext.Provider value={{ 
      onError
    }}>
      { state.isError ? (
        <ErrorPage 
          errCode={state.errCode}
          errMessage={state.errMessage}
          onBack={() => {
            if ( state.onBack !== undefined ) {
              state.onBack()
            } else {
              history.goBack()
            }
            setState(fp.set('isError', false))
          }}
        />
      ) : children }  
    </ErrorContext.Provider>
  )
}

export default ErrorContext